import React from 'react';
import Select from 'react-select';
import style from './DistributorsTree.module.css';
import {UserClient} from '../../../types/TypesUser';
import {useTranslation} from 'react-i18next';

type Props = {
	usersList: UserClient[];
	handleChange: (client: UserClient) => void;
};
const DistributorsSearchSelect = ({usersList, handleChange}: Props) => {
	const {t} = useTranslation();
	const options = usersList.map((user: UserClient) => ({
		label: user.name,
		value: user.client_id,
		user,
	}));
	const customFilterOption = (option: any, rawInput: string) => {
		// Функция для фильтрации по пользовательскому полю 'searchKey'

		const contract = option?.data?.contract?.toLowerCase();
		const input = rawInput.toLowerCase();
		return (
			option.label.toLowerCase().includes(input) ||
			(contract && contract.includes(input))
		);
	};
	return (
		<div className={style.reactSelectContainer}>
			<Select
				options={options}
				filterOption={customFilterOption}
				onChange={(newValue) => {
					if (!newValue) return;
					handleChange(newValue.user);
				}}
				styles={{
					control: (baseStyles, state) => ({
						...baseStyles,
						display: 'flex',
						alignItems: 'center',
						minHeight: '45px',
						height: '45px',
						borderColor: state.isFocused ? '#bc9876' : '#C4C4C4',
						borderRadius: '8px',
						boxShadow: state.isFocused
							? '0 2px 12px rgba(188, 152, 118, 0.2)'
							: 'none',
						backgroundColor: '#FFFFFF',
						color: '#333',
						transition: 'all 0.3s ease',
						'&:hover': {
							borderColor: '#bc9876',
							boxShadow: '0 2px 8px rgba(188, 152, 118, 0.15)',
						},
					}),
					container: (styles) => ({
						...styles,
						height: '45px',
					}),
					input: (styles) => ({
						...styles,
						margin: '0px',
						height: '45px',
						color: '#333',
					}),
					valueContainer: (styles) => ({
						...styles,
						height: '45px',
						padding: '0 12px',
					}),
					placeholder: (styles) => ({
						...styles,
						color: '#999',
						fontSize: '14px',
					}),
					singleValue: (styles) => ({
						...styles,
						color: '#333',
						fontSize: '14px',
					}),
					option: (styles, {isFocused, isSelected}) => ({
						...styles,
						backgroundColor: isSelected
							? '#bc9876'
							: isFocused
								? 'rgba(188, 152, 118, 0.1)'
								: '#FFFFFF',
						color: isSelected ? '#FFFFFF' : '#333',
						cursor: 'pointer',
						transition: 'all 0.2s ease',
						fontSize: '14px',
						'&:active': {
							backgroundColor: '#bc9876',
						},
					}),
					menu: (styles) => ({
						...styles,
						borderRadius: '8px',
						boxShadow: '0 4px 16px rgba(0, 0, 0, 0.1)',
						overflow: 'hidden',
						border: '1px solid rgba(188, 152, 118, 0.2)',
					}),
					menuList: (styles) => ({
						...styles,
						padding: '4px',
					}),
				}}
				isSearchable
				placeholder={t('Введіть номер контракту')}
			/>
		</div>
	);
};

export default DistributorsSearchSelect;
